import { buttonFaq } from './js/faq.js';
import { manageModal } from './js/work-together.js';
import './js/reviews.js';
import './js/hero.js';
import './js/my-projects';
import { onSwitchTheme } from './js/switch-button.js';
buttonFaq();
manageModal();
onSwitchTheme();
